import { useState } from 'react';
import Swal from 'sweetalert2';
import QuestionFilter from './QuestionFilter';
import QuestionSearch from './QuestionSearch';
import type { Question } from '../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';

interface SearchAndFilterProps {
	questions: Question[];
	questionBankID: QuestionBankID;
	resetQuestions: () => void;
	setFilteredQuestions: (questions: Question[]) => void;
	setShowNoResultsMSG: (value: boolean) => void;
}

const SearchAndFilter = ({
	questions,
	questionBankID,
	resetQuestions,
	setFilteredQuestions,
	setShowNoResultsMSG
}: SearchAndFilterProps) => {
	const [searchBy, setSearchBy] = useState<'question' | 'explanation'>(
		'question'
	);
	const [issuesFilter, setIssuesFilter] = useState(false);
	const [showFilter, setShowFilter] = useState(false);

	const handleDirectPull = async () => {
		const result = await Swal.fire({
			title: 'Confirm Fresh Pull',
			text: 'Are you sure you want to make a fresh pull?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Yes, pull',
			cancelButtonText: 'No, cancel'
		});

		if (result.isConfirmed) {
			// questionsFromDB();
		} else {
			await Swal.fire(
				'Cancelled',
				'No request was made to Firestore DB',
				'info'
			);
		}
	};

	const handleDirectPullClick = () => void handleDirectPull();

	// #region SEARCH
	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setShowNoResultsMSG(false);
		setShowFilter(false);
		setIssuesFilter(false);

		const result = questions.filter((question) => {
			const inQuestionFilter = question[searchBy]
				.toLowerCase()
				.includes(e.target.value.toLowerCase());
			const sameCatID = question.categoryID
				.toLowerCase()
				.includes(e.target.value.toLowerCase());
			const inQuestionID = question.id
				.toLowerCase()
				.includes(e.target.value.toLowerCase());
			return (
				sameCatID ||
				inQuestionFilter ||
				inQuestionID ||
				question.id.includes(e.target.value)
			);
		});

		setFilteredQuestions(result);
		if (result.length < 1) {
			setShowNoResultsMSG(true);
		}

		if (e.target.value === '') {
			resetQuestions();
			setShowFilter(false);
		}
	};
	// #endregion

	return (
		<>
			<QuestionSearch
				handleSearch={handleSearch}
				resetQuestions={resetQuestions}
				searchBy={searchBy}
				setSearchBy={setSearchBy}
				showFilter={showFilter}
				setShowFilter={setShowFilter}
				setShowNoResultsMSG={setShowNoResultsMSG}
			/>

			{showFilter && (
				<>
					<hr className='w-3/4 mx-auto my-8' />
					{showFilter && (
						<QuestionFilter
							questions={questions}
							questionBankID={questionBankID}
							setFilteredQuestions={setFilteredQuestions}
							setShowNoResultsMSG={setShowNoResultsMSG}
							showFilter={showFilter}
							setShowFilter={setShowFilter}
							resetQuestions={resetQuestions}
						/>
					)}

					{/* Get Questions Directly from DB */}
					{!issuesFilter && (
						<div className='row hide-on-med-and-down'>
							<div className='col s12'>
								<button
									className='btn bg-secondary'
									onClick={handleDirectPullClick}>
									Get Questions Directly from DB
								</button>
							</div>
						</div>
					)}
				</>
			)}

			<hr className='w-3/4 mx-auto my-8' />
		</>
	);
};
export default SearchAndFilter;
